exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-5207ece6] {\n  max-width: 500px;\n}\n", ""]);

// exports
